import { createContext, useContext, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchDishwasherData } from '../services/ioBroker'

const ApplianceContext = createContext(null)

export function useAppliance() {
  return useContext(ApplianceContext)
}

export function ApplianceProvider({ children }) {
  const dishwasherQ = useQuery({ queryKey: ['dishwasher'], queryFn: fetchDishwasherData, refetchInterval: 30_000 })

  const value = useMemo(() => ({
    dishwasher: dishwasherQ.data ?? null,
  }), [dishwasherQ.data])

  return <ApplianceContext.Provider value={value}>{children}</ApplianceContext.Provider>
}
